import { createFileRoute, Link } from '@tanstack/react-router'
import { Icon } from '@/components/icons'
import { LiffMiniDashboard } from '@/components/liff/LiffMiniDashboard'
import { LiffShell } from '@/components/liff/LiffShell'

export const Route = createFileRoute('/liff/')({
  component: LiffHomePage,
})

const ACTIONS = [
  {
    to: '/liff/outstanding',
    title: 'ใบเสร็จค้างชำระ',
    description: 'ดูยอดค้างและรายละเอียดบิล',
    icon: 'mdi:file-clock-outline',
    accent: 'bg-rose-600',
  },
  {
    to: '/liff/wage',
    title: 'บันทึกค่าจ้าง',
    description: 'ลงค่าจ้างพนักงานรายวัน',
    icon: 'mdi:cash-plus',
    accent: 'bg-emerald-600',
  },
  {
    to: '/liff/expense',
    title: 'บันทึกค่าใช้จ่าย',
    description: 'ลงรายการค่าใช้จ่ายสาขา',
    icon: 'mdi:receipt-text-outline',
    accent: 'bg-blue-600',
  },
] as const

function LiffHomePage() {
  return (
    <LiffShell title="เมนูหลัก">
      <LiffMiniDashboard />
      <p className="mx-auto mb-4 max-w-md text-center text-sm text-slate-500">
        เลือกรายการที่ต้องการ
      </p>
      <ul className="mx-auto flex max-w-md flex-col gap-4">
        {ACTIONS.map((action) => (
          <li key={action.to}>
            <Link
              to={action.to}
              className="flex min-h-[88px] items-center gap-4 rounded-2xl border border-border/50 bg-white p-5 shadow-sm transition active:scale-[0.98]"
            >
              <span
                className={`flex size-14 shrink-0 items-center justify-center rounded-xl text-white ${action.accent}`}
              >
                <Icon icon={action.icon} className="size-8" aria-hidden />
              </span>
              <span className="flex flex-col gap-1 text-left">
                <span className="text-lg font-semibold text-slate-900">{action.title}</span>
                <span className="text-sm text-slate-500">{action.description}</span>
              </span>
              <Icon icon="lucide:chevron-right" className="ml-auto size-6 text-slate-400" />
            </Link>
          </li>
        ))}
      </ul>
    </LiffShell>
  )
}
